import { render } from "./justeFaux.vue?vue&type=template&id=1c4d9d42&scoped=true"
import script from "./justeFaux.vue?vue&type=script&lang=js"
export * from "./justeFaux.vue?vue&type=script&lang=js"

import "./justeFaux.vue?vue&type=style&index=0&id=1c4d9d42&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d9d42"]])

export default __exports__